
import React, { useState, useEffect } from 'react';

const TranscribingText: React.FC = () => {
  const text = "in seconds.";
  // 0: Audio (4 waves)
  // 1: "in"
  // 2: "in seconds."
  const [stage, setStage] = useState(0);

  useEffect(() => {
    let timeout: any;
    
    // Wave animation is 0.8s per cycle (defined in tailwind config as soundWave)
    // 4 waves = 3.2s
    if (stage === 0) {
        // Audio Phase
        timeout = setTimeout(() => setStage(1), 3200); 
    } else if (stage === 1) {
        // "in" appears
        timeout = setTimeout(() => setStage(2), 600); // 600ms to read "in" before "seconds" appears
    } else if (stage === 2) {
        // "seconds." appears (Full text)
        timeout = setTimeout(() => setStage(0), 4000); // Hold text for 4s
    }

    return () => clearTimeout(timeout);
  }, [stage]);

  return (
    <span className="inline-grid relative align-bottom pb-2 mx-1.5">
      {/* Invisible text to reserve layout space exactly matching the font */}
      <span className="invisible font-extrabold whitespace-nowrap select-none" aria-hidden="true">
        {text}
      </span>

      {/* Audio Waveform Layer */}
      <span 
        className={`absolute inset-0 flex items-center justify-between pointer-events-none transition-opacity duration-500 ${
            stage === 2 ? 'opacity-0' : 'opacity-100'
        }`}
        aria-hidden="true"
      >
        {Array.from({ length: 28 }).map((_, i) => (
            <span
                key={i}
                className="w-1.5 bg-gradient-to-t from-brand-primary to-brand-secondary rounded-full animate-sound-wave"
                style={{ 
                    height: '80%', 
                    animationDelay: `${i * 0.05}s`,
                    animationDuration: '0.8s'
                }}
            />
        ))}
      </span>

      {/* Text Layer */}
      <span 
        className="absolute inset-0 overflow-hidden font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-brand-primary to-brand-secondary whitespace-nowrap transition-[width] ease-out"
        style={{
            // "in " is approx 27% of the total width
            width: stage === 0 ? '0%' : stage === 1 ? '27%' : '100%',
            transitionDuration: stage === 0 ? '0s' : '0.4s'
        }}
      >
        {text}
      </span>
    </span>
  );
};

export default TranscribingText;